import { apiClient } from "./client";

// Owner-scoped calls deliberately accept no username/displayName argument.
export const getPortfolio = () => apiClient.get("/auth/portfolio");
export const purchaseStock = (purchase) => apiClient.post("/auth/purchase", purchase);
export const editPortfolioOrder = (order) => apiClient.put("/auth/portfolio/edit-order", order);
export const removePortfolioPosition = (ticker, datetime) => apiClient.delete("/auth/portfolio/remove-position", { params: { ticker, datetime } });
export const getFavorites = () => apiClient.get("/auth/favorites");
export const checkFavorite = (ticker) => apiClient.get("/auth/checkFavorite", { params: { ticker } });
export const addFavorite = (ticker) => apiClient.post("/auth/addFavorite", { ticker });
export const removeFavorite = (ticker, watchlistId) => apiClient.post("/auth/removeFavorite", { ticker, ...(watchlistId ? { watchlistId } : {}) });
export const createWatchlist = (name, components) => apiClient.post("/auth/watchlists", { name, ...(components ? { components } : {}) });
export const renameWatchlist = (watchlistId, name) => apiClient.patch(`/auth/watchlists/${encodeURIComponent(watchlistId)}`, { name });
export const deleteWatchlist = (watchlistId) => apiClient.delete(`/auth/watchlists/${encodeURIComponent(watchlistId)}`);

export function getApiErrorMessage(error) {
  const status = error.response?.status;
  if (status === 400) return "Please check the submitted information.";
  if (status === 403) return "You do not have permission to access this data.";
  if (status === 409) return "An account with those details already exists. Please sign in or recover your password.";
  if (status === 429) return "Too many requests. Please wait before trying again.";
  return "The service is temporarily unavailable. Please try again.";
}
